const initShare = (shareBtns) => {
    shareBtns.forEach((button) => {
        button.addEventListener("click", async () => {
            try {
                const currentUrl = window.location.href;

                await navigator.clipboard.writeText(currentUrl);

                button.classList.add("is-success");

                // Reset after 2 seconds
                setTimeout(() => {
                    button.classList.remove("is-success");
                }, 2000);
            } catch (err) {
                console.error("Failed to copy: ", err);
            }
        });
    });
};

export default initShare;
